import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div
      data-testid="not-found-page"
      className="min-h-screen bg-brand-bg flex items-center justify-center px-4"
    >
      <div className="text-center max-w-md">
        <div className="text-xs font-semibold uppercase tracking-widest text-brand-gold mb-3">
          Errore 404
        </div>
        <h1 className="text-3xl text-brand-ink mb-3">Pagina non trovata</h1>
        <p className="text-brand-muted mb-6">
          La pagina che stai cercando non esiste o è stata spostata.
        </p>
        <Link to="/" className="btn-primary inline-flex" data-testid="not-found-home-link">
          Torna alla home
        </Link>
      </div>
    </div>
  );
}
